module.exports = __webpack_public_path__ + "img/clio-360px.4155a81f.png";